import { ImgHTMLAttributes } from "react";

import { getSrcSet } from "@/components/wpl/image/src";

export interface ContentPlatformImageProps
    extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt: string;
    contentType?: string;
    baseWidth?: number; //max width needed in pixels at 1x resolution
}

/* CPAPI images are hosted on Contentful which allows transformations on images
https://www.contentful.com/developers/docs/references/images-api/#/reference/changing-formats

The basic piece is to convert all PNGs to webp,
but we can also do more with responsive images and srcset, etc
*/

export const ContentPlatformImage = ({
    contentType,
    src,
    alt,
    baseWidth,
    ...rest
}: ContentPlatformImageProps) => {
    const queryPairs: string[] = [];
    let srcSet: string[] = [];

    if (contentType === "image/png") {
        queryPairs.push("fm=webp");

        if (baseWidth) {
            srcSet = getSrcSet(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }

    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";

    return (
        // eslint-disable-next-line no-restricted-syntax
        <img
            loading="lazy"
            {...rest}
            src={`${src}${queryString}`}
            srcSet={srcSet.length > 0 ? srcSet.join(",") : undefined}
            alt={alt}
        />
    );
};
